import styled from 'styled-components';
import { StyledCloseLink } from '../walkthrough/Styled';

export const StyledTermList = styled.div`
  display: grid;
  row-gap: 2.5rem;
`;

export const StyledTermBox = styled.div`
  background-color: ${(props) => props.theme.colors.greys.white};
  border: 1px solid ${(props) => props.theme.colors.greys.grey20};
  padding: 1.75rem 1.25rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  max-height: 20rem;
  word-break: break-all;
`;

export const StyledTermAgreeCheckList = styled.div`
  display: grid;
  row-gap: 0.75rem;

  ${({ theme }) => theme.mediaQueries.min.md} {
    row-gap: 1rem;
  }
`;

export const StyledTermBottom = styled.div`
  margin-top: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  & {
    .agree-button,
    ${StyledCloseLink} {
      margin-top: 1.5rem;
    }

    .agree-button {
      padding: 0.75rem 5rem;
    }
  }
`;
